module.exports = __webpack_public_path__ + "img/bsidd-3.a11435dd.jpg";